import React from 'react';
import { cn } from '@/utils/cn';

function Link({ children, className = '', disabled = false, ...rest }) {
  return (
    <button
      type="button"
      aria-label="link button"
      className={cn(
        `flex justify-center items-center px-24 py-10 border-unset`,
        className,
        {
          'bg-white cursor-not-allowed': disabled,
        },
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Link;
